import {
  SuccessfullyMessageBarDispatch,
  ToastContextDispatch,
  UserInfoContext,
} from "Context/CommonContext";
import moment from "moment";
import AttendanceCardList from "Pages/MySchedule/Attendance/AttendanceCardList";
import AttendanceHeader from "Pages/MySchedule/Attendance/AttendanceHeader";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  deleteAPI,
  getAPIRequest,
} from "utilFunctions/Axios/AxiosRequestConfiguration";
import deleteRequestInterface from "utilFunctions/Axios/deleteRequestInterface";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import {
  BASE_URL,
  DELETE_FLAG_STUDENT_FROM_REPORT,
  GET_STUDENT_ATTENDANCE,
  POST_MARK_ATTENDANCE,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
// import AttendanceStudentReport from "./AttendanceStudentReport";
import ReportStudentAttendance from "./ReportStudentAttendance";
const DivViewTableContainer = styled<any>("div")`
  padding: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "0px 20px 20px 48px" : "0px"};
  overflow: hidden !important;
`;

const AttendanceHome = () => {
  const { screen }: any = useWindowSize();
  const location = useLocation();
  const navigate = useNavigate();
  const successMessageInfor = useContext<any>(SuccessfullyMessageBarDispatch);
  const [selectedSchedule, setSelectedSchedule] = useState<any>(
    location?.state &&
      location?.state != null &&
      location?.state?.selectedSchedule &&
      location?.state?.selectedSchedule != null
      ? location?.state?.selectedSchedule
      : {}
  );
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [studentBACKUP, setstudentBACKUP] = useState<any>([]);
  const [studentlist, setStudentList] = useState<any>([]);
  const [studentLOPlist, setStudentLOPList] = useState<any>([]);
  const userInfo = useContext<IUserInfo>(UserInfoContext);

  const [isStudentListLoading, setIsStudentListLoading] =
    useState<boolean>(false);
  const [presentStudentList, setPresentStudentList] = useState<any>([]);
  const [onlineStudentList, setOnlineStudentList] = useState<any>([]);
  const [isUnmarkedVisible, setIsUnmarkedVisible] = useState<any>(false);
  const [totalStudentCount, setTotalStudentCount] = useState<
    number | undefined
  >();
  const [selectedFilter, setSelectedFilter] = useState<any>({
    label: "Total Students",
    value: "total",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportedStudentList, setReportedStudentlist] = useState<any>([]);
  useEffect(() => {
    if (location && location?.state && location.state != null) {
      const { selectedSchedule, attendanceStatus } = location.state;
      if (selectedSchedule && selectedSchedule != null) {
        setSelectedSchedule(selectedSchedule);
        const { batchId, batchTimeTableId, endTime } = selectedSchedule;
        let newUrl =
          BASE_URL +
          GET_STUDENT_ATTENDANCE +
          `?BatchId=${batchId}&lectureId=${batchTimeTableId}&branch=${selectedSchedule?.branchId}`;
        const epochLectureTime = new Date(endTime).getTime();
        if (selectedSchedule?.alcLecture != undefined) {
          newUrl = newUrl + "&alcLecture=" + selectedSchedule?.alcLecture;
        }
        if (attendanceStatus == "mark") {
          newUrl =
            newUrl + "&attendanceStatus=Unmarked&punchDate=" + epochLectureTime;
        } else {
          newUrl =
            newUrl + "&attendanceStatus=Marked&punchDate=" + epochLectureTime;
        }
        fetchData(newUrl);
      }
    }
  }, [location]);
  const fetchData = async (url: string) => {
    setIsStudentListLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        if (response?.data?.data) {
          setIsStudentListLoading(false);
          const data = response?.data?.data;
          setStudentList(data);
          setstudentBACKUP(data);
          const nonFlaggedStudents = data.filter((item: any) => !item.hasFlag);
          setTotalStudentCount(nonFlaggedStudents.length);
          const onlineStudens = data.filter(
            (el: any) => el.attendanceType == "O"
          );
          if (onlineStudens && Array.isArray(onlineStudens)) {
            const newOnlineStudentsList = onlineStudens.map(
              (item: any) => item.psid
            );
            setOnlineStudentList(newOnlineStudentsList);
            console.log(onlineStudens, "onlineStudens", newOnlineStudentsList);
          }
        } else {
          setIsStudentListLoading(false);
          setStudentList([]);
          setstudentBACKUP([]);
        }
      },
      failure: (error: any) => {
        setIsStudentListLoading(false);
        console.log("selectedSchedule", error);
      },
    });
  };

  const fetchLeftOutStudents = async () => {
    const { batchId, branchId } = selectedSchedule;
    const lopUrl = `attendace/leftOutStudents?batchId=${batchId}&branchCode=${branchId}`;
    await getAPIRequest({
      url: BASE_URL + lopUrl,
      success: (response: any) => {
        if (response?.data?.data?.leftOutStudents) {
          const previousReportedStudents = studentBACKUP
            .filter((el: any) => el.hasFlag)
            .map((item: any) => item.psid);

          const data = response?.data?.data?.leftOutStudents;
          const dataEdited: any = [];
          data.map((el: any) => {
            if (!previousReportedStudents.includes(el.psid)) {
              dataEdited.push({
                ...el,
                isLopStudent: true,
              });
            }
          });
          if (dataEdited && dataEdited.length > 0) {
            setstudentBACKUP((prevStudentBACKUP: any) => [
              ...prevStudentBACKUP,
              ...dataEdited,
            ]);
            setStudentLOPList(dataEdited);
          } else {
            setStudentLOPList("No data");
          }
        } else {
          setStudentLOPList("No data");
        }
      },
      failure: (error: any) => {
        setStudentLOPList([]);
        console.log("selectedSchedule", error);
      },
    });
  };
  const handleUnmarkFilterForStudent = (val: any) => {
    if (val) {
      const filteredArray = studentBACKUP.filter(
        (el: any) => el.attendanceType == null && !el.isLopStudent
      );
      const filteredArrayLOP = studentBACKUP.filter(
        (el: any) => el.attendanceType == null && el.isLopStudent
      );
      setStudentList([...filteredArray]);
      setStudentLOPList([...filteredArrayLOP]);
    } else {
      const filteredArray = studentBACKUP.filter((el: any) => !el.isLopStudent);
      const filteredArrayLOP = studentBACKUP.filter(
        (el: any) => el.isLopStudent
      );
      setStudentList([...filteredArray]);
      setStudentLOPList([...filteredArrayLOP]);
    }
  };
  const handleAttendance = (data: any) => {
    const prevList = [...presentStudentList];
    prevList.push(data.psid);
    const uniqueSet: Set<number> = new Set(prevList);
    const uniqueArray: number[] = Array.from(uniqueSet);
    setPresentStudentList(uniqueArray);
  };
  const handleAbsent = (data: any) => {
    const prevList = [...presentStudentList];
    const filteredList = prevList.filter((item: any) => item != data.psid);
    setPresentStudentList([...filteredList]);
  };

  const handleStudentStatus = (data: any, val: any) => {
    const psid = data.psid;
    if (data?.isLopStudent) {
      const finded = studentLOPlist.find(
        (el: any) =>
          el.psid == data.psid &&
          (el.attendanceType != undefined || el.attendanceType != null)
      );
      if (finded) {
        const updatedUsers = studentLOPlist.map((student: any) => {
          if (student.psid === psid) {
            return { ...student, attendanceType: undefined };
          }
          return student;
        });
        setStudentLOPList(updatedUsers);
      } else {
        const updatedUsers = studentLOPlist.map((student: any) => {
          if (student.psid === psid) {
            return { ...student, attendanceType: val };
          }
          return student;
        });
        setStudentLOPList(updatedUsers);
      }
    } else {
      const updatedUsers = studentlist.map((student: any) => {
        if (student.psid === psid) {
          return { ...student, attendanceType: val };
        }
        return student;
      });
      setStudentList(updatedUsers);
    }
    const finded = studentBACKUP.find(
      (el: any) =>
        el.psid == data.psid &&
        data?.isLopStudent &&
        (el.attendanceType != undefined || el.attendanceType != null)
    );
    if (finded) {
      const updatedStudent = studentBACKUP.map((student: any) => {
        if (student.psid === psid) {
          return { ...student, attendanceType: undefined };
        }
        return student;
      });
      setstudentBACKUP(updatedStudent);
    } else {
      const updatedStudent = studentBACKUP.map((student: any) => {
        if (student.psid === psid) {
          return { ...student, attendanceType: val };
        }
        return student;
      });
      setstudentBACKUP(updatedStudent);
    }
  };
  const handleSearchStudent = (value: any) => {
    const casevalue = value.toLowerCase();
    const filteredArray = studentBACKUP.filter(
      (el: any) =>
        el.studentName.toLowerCase().includes(casevalue) && !el.isLopStudent
    );
    const filteredArrayLOP = studentBACKUP.filter(
      (el: any) =>
        el.studentName.toLowerCase().includes(casevalue) && el.isLopStudent
    );
    setStudentList([...filteredArray]);
    setStudentLOPList([...filteredArrayLOP]);
  };
  const handleFilterForStudent = (val: any) => {
    setSelectedFilter(val);
    const { value } = val;
    if (value == "total") {
      setStudentList([...studentBACKUP]);
    } else {
      const filteredArray = studentBACKUP.filter(
        (el: any) => el.attendanceType == value
      );
      setStudentList([...filteredArray]);
    }
  };
  const { makeRequest: PostMarkAttendance } = usePutPostAPI(
    (data: any) => {
      if (data && data["data"]) {
        if (location.state?.referrer) {
          navigate(location.state.referrer, {
            replace: true,
            state: {
              ...location.state,
            },
          });
        } else {
          navigate(-1);
        }
        successMessageInfor({
          message: `Attendance saved for ${selectedSchedule.eventName}. You can edit it till end of the day only.`,
          isShow: true,
        });
      }
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message:
          error["response"]["data"]["internalCode"] ||
          error["response"]["data"]["message"],
      });
    },
    "PUT"
  );

  const handleMarkAttendance = () => {
    const { batchId, batchTimeTableId } = selectedSchedule;
    const { courseId } = location.state;
    const nonFlaggedStudentList = studentBACKUP.filter(
      (item: any) =>
        !item.hasFlag &&
        !item.isLopStudent &&
        item?.attendanceType &&
        item?.attendanceType != null
    );
    const nonFlaggedLOPStudentList = studentBACKUP.filter(
      (item: any) =>
        !item.hasFlag &&
        item.isLopStudent &&
        item?.attendanceType &&
        item?.attendanceType != null
    );
    let obj: any = {
      batchId: batchId,
      lectureId: batchTimeTableId,
      eventType: selectedSchedule?.eventType,
      studentsAttendance: [...nonFlaggedStudentList],
      syllabusList: selectedSchedule?.syllabusList,
      branch: selectedSchedule?.branchId,
    };
    const url = BASE_URL + POST_MARK_ATTENDANCE;
    if (courseId) {
      obj["coursePresent"] = true;
    }
    if (nonFlaggedStudentList.length == totalStudentCount) {
      if (nonFlaggedLOPStudentList.length) {
        const postRequestObject = {
          facultyId: userInfo?.employeeId,
          room: selectedSchedule?.room,
          className: selectedSchedule?.class,
          branchId: selectedSchedule?.branchId,
          remarks: "",
          // captureTime: Date.now(),
          leftoutStudentsAttendance: [...nonFlaggedLOPStudentList],
          scheduledStartDate: selectedSchedule?.startTime,
          scheduledEndDate: selectedSchedule?.endTime,
        };
        obj = {
          ...obj,
          ...postRequestObject,
        };
        PostMarkAttendance(url, obj);
      } else if (nonFlaggedStudentList.length) {
        PostMarkAttendance(url, obj);
      }
    } else {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "Post Student count not matched with GET Student count",
      });
    }
  };
  const handleReportedStudentList = (reportList: any) => {
    const newReportlist = [...studentlist, ...reportList];
    // setReportedStudentlist(newReportlist);
    setStudentList([...newReportlist]);

    setstudentBACKUP((prevStudentBKP: any) => [
      ...prevStudentBKP,
      ...reportList,
    ]);
  };

  const handleDeleteStudentStatus = (student: any) => {
    const { batchTimeTableId, startTime } = selectedSchedule;
    const copyReportList = [...reportedStudentList];
    const copyStudentsList = [...studentlist];
    const urls: any = BASE_URL + DELETE_FLAG_STUDENT_FROM_REPORT;
    const obj: any = {
      psid: student.psid,
      punchDate: moment(startTime).format("YYYY-MM-DD"),
      lectureId: batchTimeTableId,
      branch: selectedSchedule?.branchId,
    };
    deleteAPI({
      url: urls,
      success: (data: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Success",
          message:
            data["message"] ||
            `Reported student: ${student.studentName} successfully deleted from lecture`,
        });
        const filteredReportStudentList = copyReportList.filter(
          (el: any) => el.psid != student.psid
        );
        const filteredStudentCopyList = copyStudentsList.filter(
          (el: any) => el.psid != student.psid
        );
        setReportedStudentlist([...filteredReportStudentList]);
        setStudentList([...filteredStudentCopyList]);
        const filteredStudentBKPCopyList = studentBACKUP.filter(
          (el: any) => el.psid != student.psid
        );
        setstudentBACKUP([...filteredStudentBKPCopyList]);
      },
      failure: (err: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err["message"],
        });
      },
      body: obj,
      method: "DELETE",
    } as deleteRequestInterface);
  };
  const nonLOPStudentsLength = studentBACKUP.filter(
    (item: any) => !item.isLopStudent
  ).length;
  const presentLength = studentBACKUP.filter(
    (item: any) => item.attendanceType == "A" && !item.isLopStudent
  ).length;
  const onlineLength = studentBACKUP.filter(
    (item: any) => item.attendanceType == "O" && !item.isLopStudent
  ).length;
  const absentLength = studentBACKUP.filter(
    (item: any) => item.attendanceType == "UA" && !item.isLopStudent
  ).length;
  const unmarkedlength =
    nonLOPStudentsLength - (presentLength + onlineLength + absentLength);

  const LOPStudentsLength = studentBACKUP.filter(
    (item: any) => item.isLopStudent
  ).length;
  const presentLengthLOP = studentBACKUP.filter(
    (item: any) => item.attendanceType == "A" && item.isLopStudent
  ).length;
  const onlineLengthLOP = studentBACKUP.filter(
    (item: any) => item.attendanceType == "O" && item.isLopStudent
  ).length;
  const absentLengthLOP = studentBACKUP.filter(
    (item: any) => item.attendanceType == "UA" && item.isLopStudent
  ).length;
  const unmarkedlengthLOP =
    LOPStudentsLength - (presentLengthLOP + onlineLengthLOP + absentLengthLOP);
  const isLOPStudentSaveEnable = true;
  // studentLOPlist &&
  // Array.isArray(studentLOPlist) &&
  // studentLOPlist.length &&
  // unmarkedlengthLOP >= studentLOPlist.length
  //   ? false
  //   : true;

  return (
    <DivViewTableContainer screen={screen}>
      <ReportStudentAttendance
        selectedSchedule={selectedSchedule}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleReportedStudentList={handleReportedStudentList}
      />
      <AttendanceHeader
        screen={screen}
        scheduledata={selectedSchedule}
        SearchButtonHandler={selectedSchedule}
        handleSearchStudent={handleSearchStudent}
        totalStudentList={studentBACKUP}
        isUnmarkedVisible={isUnmarkedVisible}
        setIsUnmarkedVisible={setIsUnmarkedVisible}
        handleUnmarkFilterForStudent={handleUnmarkFilterForStudent}
        setIsModalOpen={setIsModalOpen}
      />
      <AttendanceCardList
        isStudentListLoading={isStudentListLoading}
        setIsModalOpen={setIsModalOpen}
        scheduleData={selectedSchedule}
        studentList={studentlist}
        reportedStudentList={reportedStudentList}
        screen={screen}
        handleAttendance={handleAttendance}
        handleAbsent={handleAbsent}
        handleStudentStatus={handleStudentStatus}
        presentStudentList={presentStudentList}
        onlineStudentList={onlineStudentList}
        totalStudentList={studentBACKUP}
        isUnmarkedVisible={isUnmarkedVisible}
        setIsUnmarkedVisible={setIsUnmarkedVisible}
        selectedFilter={selectedFilter}
        handleFilterForStudent={handleFilterForStudent}
        presentLength={presentLength}
        absentLength={absentLength}
        unmarkedlength={unmarkedlength}
        unmarkedlengthLOP={unmarkedlengthLOP}
        isLOPStudentSaveEnable={isLOPStudentSaveEnable}
        onlineLength={onlineLength}
        handleMarkAttendance={handleMarkAttendance}
        handleUnmarkFilterForStudent={handleUnmarkFilterForStudent}
        handleDeleteStudentStatus={handleDeleteStudentStatus}
        fetchLeftOutStudents={fetchLeftOutStudents}
        studentLOPlist={studentLOPlist}
      />
    </DivViewTableContainer>
  );
};

export default AttendanceHome;
